import React, { Suspense } from 'react';
import PrivacyPolicy from 'features/legal/routes/PrivacyPolicy';
import TermsAndConditions from 'features/legal/routes/TermsAndConditions';
import BagelSmsConsentInfo from 'features/legal/routes/BagelSmsConsentInfo';
import BagelSmsConsent from 'features/auth/routes/BagelSmsConsent';
import { Loader } from '@urbantxt/loader';

/** Always reachable, no login required — Twilio A2P campaign review must be able to open these. */
const legalRoutes = [
  {
    path: '/privacy-policy',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: '/terms-and-conditions',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <TermsAndConditions />
      </Suspense>
    ),
  },
  {
    path: '/bagel-sms-consent',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <BagelSmsConsent />
      </Suspense>
    ),
  },
  {
    path: '/bagel-sms-consent-info',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <BagelSmsConsentInfo />
      </Suspense>
    ),
  },
];

export default legalRoutes;
